import NotificationComponent from "./NotificationComponent";
export default NotificationComponent;
